import { mergeMap, withLatestFrom } from 'rxjs/operators';
import { IEpic, isTypeOfAndGetPayload } from '@cbridge-utils/redux-observable';
import { IGetSelectorStateType } from '@cbridge-utils/reselect';
import { PriceFilteringAction } from '@cbridge-packages/price-filtering-profile';
import { detailsSidebarResourceIdSelector, DetailsSidebarAction } from '@cbridge-packages/details-sidebar';

type IState = IGetSelectorStateType<typeof detailsSidebarResourceIdSelector>;

export const closePriceFilteringBeforeRemoveEpic: IEpic<IState> = (action$, state$) => action$.pipe(
  isTypeOfAndGetPayload(PriceFilteringAction.remove.started),
  withLatestFrom(state$),
  mergeMap(([payload, state]) => {
    const { priceFilteringId } = payload;
    const openedDetailsId = detailsSidebarResourceIdSelector(state);

    if (openedDetailsId !== undefined && String(openedDetailsId) === String(priceFilteringId)) {
      return [
        DetailsSidebarAction.close({ skipUnsavedChangesConfirmation: true }),
      ];
    }

    return [];
  }),
);
